/**
 * Main
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */
import 'assets/scripts/auto-complete';
document.addEventListener('DOMContentLoaded', () => {
  $('.js-search-btn').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    $('.header__search').toggleClass('is-active');
    $('.p2-header__search').toggleClass('is-active');
  });
  $('.header__search').click(function (e) {
    e.stopPropagation();
  });
  $('.p2-header__search').click(function (e) {
    e.stopPropagation();
  });
  $('.js-checkbox input').click(function () {
    if ($(this).is(':checked')) {
      $('.newsletter__dropdown-block').addClass('is-active');
    } else {
      $('.newsletter__dropdown-block').removeClass('is-active');
    }
  });
  $('body').click(function () {
    $('.header__search').removeClass('is-active');
    $('.p2-header__search').removeClass('is-active');
  });
  $('.js-mobile-toggle').on('click', function (event) {
    event.preventDefault();
    $('html').toggleClass('is-menu-open');
  });
  $('.header__menu ul li ul').parent('li').addClass('has-children');
  $('.p2-header__menu ul li ul').parent('li').addClass('has-children');
  $('.share_counter').click(function () {
    var postid = $(this).attr('id');
    var data = {
      'action': 'sharecount',
      'postid': postid
    };
    $.ajax({
      url: loadmore_params.ajaxurl,
      data: data,
      type: 'POST',
      success: function (data) {
        console.log(data);
      }
    });
  });
  $('#autosearch').autoComplete({
    source: function (name, response) {
      $.ajax({
        type: 'POST',
        dataType: 'json',
        url: loadmore_params.ajaxurl,
        data: 'action=get_listing_names&name=' + name,
        success: function (data) {
          response(data);
        }
      });
    }
  });
  $('#increment_counter').click(function (e) {
    jQuery.ajax({
      url: loadmore_params.ajaxurl,
      type: 'post',
      data: {
        action: 'increment_counter'
      },
      success: function (response) {
        $('#increase_count').text(response);
      }
    });
  });
  $('ul.menu').children('.has-children').click(function () {
    $(this).toggleClass('active-class');
    $(this).children('.sub-menu').slideToggle('slow');
  }); //     $(".plan__wrap > .plan__card:last-child").addClass("active");
  //     $(".plan__wrap > .plan__card").hover(function () {
  //     $(".plan__wrap > .plan__card").removeClass("active");
  //     $(this).addClass("active");
  //   }); 
}); // if ($(window).width() > 767) { 
// function sticky_relocate() {
// 	var window_top = $(window).scrollTop();
// 	var div_top = $('.banner-post').offset().top;
// 	if (window_top > div_top) {
// 	  $('#sticky-sidebar').addClass('stick');
// 	} else {
// 	  $('#sticky-sidebar').removeClass('stick');
// 	}
//   }
//   $(function() {
// 	$(window).scroll(sticky_relocate);
// 	sticky_relocate();
//   });
// }